import { Lobby } from "boardgame.io/react";
import { DungeonThrowdown } from "../components/Game";
import { Board } from "../components/Board";

console.log(Lobby);

function LobbyComponent() {
  return (
    <Lobby
      //   gameServer={`https://${window.location.hostname}:8000`}
      //   lobbyServer={`https://${window.location.hostname}:8001`}
      gameComponents={[{ game: DungeonThrowdown, board: Board }]}
    ></Lobby>
    // <h1>Lobby</h1>
  );
}

export default LobbyComponent;
